export function filterValidLocations(dataSource) {
  let locations = []
  if (!dataSource) return locations

  locations = dataSource.filter(station => {
    return station.Latitude && station.Longitude &&
      !isNaN(station.Latitude) && !isNaN(station.Longitude) &&
      (station.Latitude >= -90 && station.Latitude <= 90 && station.Longitude >= -180 && station.Longitude <=
        180)
  })

  return locations
}